<template>
  <div class="content-wrapper" :class="{'scrolled': scrollY > 0}">
    <div
      class="content-page"
      :class="{'min-left-hidden': menuVisible == '' || menuVisible == 'mobile', 'min-left-menu': minMenu || showRightWindow, 'open-right-window': showRightWindow}"
    >
      <Breadcrumb />
      <div class="router-page" :class="this.$route.name">
        <slot></slot>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { storeEmitter } from "../../state/store";
import Breadcrumb from "./Breadcrumb.vue";
import Footer from "./Footer.vue";

export default {
  components: { Breadcrumb, Footer },
  data() {
    return {
      minMenu: false,
      scrollY: false
    };
  },

  computed: {
    ...mapState({
      showRightWindow: state => state.showRightWindow,
      menuVisible: state => state.menuVisible
    })
  },

  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
    }
  },

  beforeMount() {
    this.scrollY = window.scrollY;
  },

  mounted() {
    storeEmitter.on("on-click-min-menu", flag => (this.minMenu = flag));
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>





// WEBPACK FOOTER //
// src/components/template/Content.vue